/*
 * @Author: Zegel
 * @Date: 2020-12-25 10:47:17
 * @LastEditTime: 2021-04-02 14:21:00
 * @LastEditors: wuchuangzhen
 * @Description: utils
 * @FilePath: /H5/src/utils/utils.ts
 */
import { parse, ParsedUrlQuery } from 'querystring'
// import pathRegexp from 'path-to-regexp'

/* eslint no-useless-escape:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/
export const isUrl = (path: string): boolean => reg.test(path)

type env = 'dev' | 'test' | 'prod' | 'gray'
interface IProcessEnv extends NodeJS.ProcessEnv {
  REACT_APP_ENV: env
}

// 是否在开发环境
export const isDevelopment: boolean = process.env.NODE_ENV === 'development'
// REACT_APP_ENV 获取 主要用于区分接口
export const getEnv = (): env => {
  const {
    REACT_APP_ENV
  }: { NODE_ENV: any; REACT_APP_ENV: env } = process.env as IProcessEnv

  // prod test dev
  return REACT_APP_ENV || 'dev'
}

export const getPageQuery = (): ParsedUrlQuery =>
  parse(window.location.href.split('?')[1])

export const getLocationVars = (): Record<string, string> => {
  // 获取location.search内容
  const locationVars: any = {}

  if (window.location.search.length > 1) {
    for (
      let aItKey,
        nKeyId = 0,
        aCouples = window.location.search.substr(1).split('&');
      nKeyId < aCouples.length;
      nKeyId++
    ) {
      aItKey = aCouples[nKeyId].split('=')
      locationVars[decodeURIComponent(aItKey[0])] =
        aItKey.length > 1 ? decodeURIComponent(aItKey[1]) : ''
    }
  }
  return locationVars
}
/* eslint guard-for-in: 0 */

export const converUrlParamsObj = (params: Record<string, any>): string => {
  const _result = []
  for (const key in params) {
    const value = params[key]
    if (value?.constructor === Array) {
      value.forEach((_value: any) => {
        _result.push(key + '=' + _value)
      })
    } else {
      _result.push(key + '=' + value)
    }
  }
  return _result.join('&')
}

/** 删除对象中空属性 */
export function removeEmptyOrNullProperties(obj: Record<string, any>): void {
  Object.keys(obj)
    .filter(
      (key) => obj[key] === '' || obj[key] === null || obj[key] === undefined
    )
    .forEach((key) => delete obj[key])
}

// 设备检测
/* eslint  no-cond-assign:0 radix:0 */
export const getUA = (): Record<string, boolean> => {
  const UA: any = {}
  const ua = navigator.userAgent.toLowerCase()
  let s
  UA.ie = (s = ua.match(/(msie\s|trident.*rv:)([\d.]+)/))
    ? parseInt(s[2])
    : false
  UA.firefox = (s = ua.match(/firefox\/([\d.]+)/)) ? parseInt(s[1]) : false
  UA.chrome = (s = ua.match(/chrome\/([\d.]+)/)) ? parseInt(s[1]) : false
  UA.opera = (s = ua.match(/opera.([\d.]+)/)) ? parseInt(s[1]) : false
  UA.safari = (s = ua.match(/version\/([\d.]+).*safari/))
    ? parseInt(s[1])
    : false
  UA.android = (s = ua.match(/android/)) ? s : false
  UA.iphone = (s = ua.match(/iphone os/)) ? s : false
  UA.ipad = (s = ua.match(/ipad/)) ? s : false
  UA.ipad13 = (s = ua.match(/mac/) && navigator.maxTouchPoints > 1)
    ? { s }
    : false
  // ipad中  ios13之后，navigator.userAgent不包含ipad字段
  UA.ios = UA.ipad || UA.iphone || UA.ipad13
  UA.isWin32 = /win32/i.test(window.navigator.platform)
  UA.isWeixin = (s = ua.match(/MicroMessenger/i)) ? !!s : false // 判断是否是在微信浏览器里面
  UA.isUcweb = (s = ua.match(/ucbrowser/)) ? !!s : false
  UA.isMqq = (s = ua.match(/mqqbrowser/)) ? !!s : false // 是否是手机qq浏览器
  UA.isWeiBo = (s = ua.match(/__weibo__/)) ? !!s : false // 是否微博浏览器
  // console.log(UA);

  UA.isMobile = UA.android || UA.ios
  return UA
}

export const getRandomStr = (number: number): string => {
  const x = 'AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz0123456789'
  let str = ''
  for (let i = 0; i < number; i++) {
    // 重点  这里利用了Math.random()函数生成的随机数大于0 小于1 我们可以
    // 用它的随机数来乘以字符串的长度,得到的也是一个随机值，再通过parseInt()
    // 函数取整，这样就可以实现字符串的随机取值了
    str += x[Math.floor(Math.random() * x.length)]
  }
  return str
}

export const getCookie = (name: string, cookieStr?: string): any => {
  let value = ''
  const strcookie = cookieStr || document.cookie
  const arrcookie = strcookie.split('; ')
  arrcookie.forEach((item) => {
    const arr = item.split('=')
    if (arr[0] === name) {
      value = arr[1]
      return arr[1]
    }
  })
  return value || ''
}

/** 函数节流---若干时间内每隔delay时间段只能触发一次函数 */
// eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/explicit-module-boundary-types
export function throttle(fn: Function, delay: number, immediate?: boolean) {
  let timer: NodeJS.Timeout | null

  return function (this: any) {
    // eslint-disable-next-line prefer-rest-params
    const args = arguments

    // 先立即执行再节流
    if (!!immediate && !timer) {
      const isNow = !timer
      isNow && fn.apply(this, args)
      timer = setTimeout(() => {
        timer && clearTimeout(timer)
        timer = null
      }, delay)
    }

    // 直接节流执行
    if (!timer && !immediate) {
      timer = setTimeout(() => {
        // timer&&clearTimeout(timer)
        timer = null
        fn.apply(this, args)
      }, delay)
    }
  }
}

// 获取屏幕缩放比例
export function getRatio(): number {
  let ratio = 0
  const screen = window.screen
  const ua = navigator.userAgent.toLowerCase()

  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio
  } else if (ua.indexOf('msie') !== -1) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (screen?.deviceXDPI && screen?.logicalXDPI) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ratio = screen?.deviceXDPI / screen?.logicalXDPI
    }
  } else if (
    window.outerWidth !== undefined &&
    window.innerWidth !== undefined
  ) {
    ratio = window.outerWidth / window.innerWidth
  }

  if (ratio) {
    ratio = Math.round(ratio * 100)
  }
  return ratio
}

/** 判断是否FB内置浏览器 */
export const isFBWeb = (): boolean => {
  const uAgent = navigator.userAgent
  return (
    uAgent.indexOf('FB_I') > -1 ||
    uAgent.indexOf('FBAV') > -1 ||
    uAgent.indexOf('FBAN') > -1 ||
    uAgent.indexOf('FBIOS') > -1
  )
}

export const copy = (text: string): void => {
  // 复制text传入的文本内容到剪切板中
  const oInput = document.createElement('input')
  oInput.value = text
  // ios 点击复制时，键盘拉起闪烁，复制失败--解决
  oInput.setAttribute('readonly', 'readonly')
  oInput.setSelectionRange(0, oInput.value.length)

  document.body.appendChild(oInput)
  oInput.select() // 选择对象

  const range = document.createRange()
  // 选中需要复制的节点
  range.selectNode(oInput)
  // 执行选中元素
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  !!window?.getSelection && window.getSelection()?.addRange(range)
  oInput.select()
  oInput.setSelectionRange(0, oInput.value.length) // 适配高版本ios

  document.execCommand('Copy') // 执行浏览器复制命令
  // 移除选中的元素
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  !!window?.getSelection && window.getSelection()?.removeAllRanges()

  oInput.className = 'oInput'
  oInput.style.display = 'none'
  console.log('success', text)

  document.body.removeChild(oInput)
}

/** kiss落地页域名pixel映射 */
const pixelMap = [
  {
    hostname: 'stardust-h5.stardustgod.com',
    fb: '1189113388588817',
    tt: 'CJ49M9BC77U1K8LNGRDG',
    pixel: ''
  },
  {
    hostname: 'pakchois.com',
    fb: '1485453421926247',
    tt: 'CJ49M9BC77U1K8LNGRDG',
    pixel: ''
  },
  {
    hostname: 'stardust-publish.com',
    fb: '820118595715063',
    tt: 'CJ49MTBC77U3DHQFNNGG',
    pixel: ''
  },
  {
    hostname: 'stardusttime.com',
    fb: '561066732625690',
    tt: 'CJ49MTBC77U3DHQFNNGG',
    pixel: ''
  }
]

/** 获取对应域名下的配置 */
export const getDomainConfig = (): Record<string, any> => {
  const hostname = location.hostname
  // 没匹配上取kiss原来的配置
  const config: Record<string, string> =
    pixelMap.find((item) => item.hostname === hostname) || pixelMap[0]
  const { mediaType = 'fb' }: any = getLocationVars()
  config.pixel = config[mediaType]
  console.log(
    '%c [ config ]-195',
    'font-size:13px; background:pink; color:#bf2c9f;',
    config
  )
  return config
}
